import BrandingModel from "../../../../Global/Models/Branding/BrandingModel";
import ImagesModel from "../../../../Global/Models/Images/ImagesModel";
import RelatedEntityRelationship from "../../../../Global/Models/Related/RelatedEntityRelationship";
import { AuthRequirementType } from "../../../../Global/Types/GlobalTypes";
import MiniGamesContext from "../MiniGamesContext";

export default class ClassicQuizBasicModel {
  public id: string = null;
  public title: string = null;
  public alternativeTitle: string = null;
  public description: string = null;
  public type: string = null;
  public images: ImagesModel = new ImagesModel();
  public participationCount: number = null;
  public questionsCount: number = null;
  public status: string = null;
  public language: string = null;
  public authRequirement: AuthRequirementType = null;
  public flags: string[] = null;
  public customFields: Record<string, string> = null;
  public labels: Record<string, string> = null;
  public branding: BrandingModel = null;
  public related: RelatedEntityRelationship[] = [];
  public time: number = null;
  public points: number = null;
  public scored: boolean = false;
  public maxAttempts: number = null;
  public averageScore: number = null;
  public perfectScore: number = null;
  public adContent: string = null;
  public context: MiniGamesContext = null;
  public createdAt: string = null;
  public updatedAt: string = null;
}
